import React from 'react';
import nakshi from '../../images/fullpage/nakshi-full.png';
const ProjectOne = () => {
    return (
        <div className="w-full flex flex-col my-8 justify-center items-center">
            <h2 className="text-white text-4xl font-caveat my-4 ">Project Details</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 my-8 justify-center items-center">
                <div className="w-10/12 lg:w-6/12 mx-auto grid grid-cols-1 text-white divide-y divide-gray-600 bg-black-custom border-0 rounded-xl px-5 py-8">
                    <div className="w-full text-left ">
                        <h2 className="text-lg font-concertone my-1" >Project Title</h2>
                        <h3 className="text-md font-poppins my-1">Nakshi - Handicraft</h3>
                    </div>
                    <div className="w-full text-left ">
                        <h2 className="text-lg font-concertone my-1" >Technology</h2>
                        <h3 className="text-md font-poppins my-1">React, Express, Node, MongoDB, Firebase, TailwindCSS, Github</h3>
                    </div>
                    <div className="w-full text-left ">
                        <h2 className="text-lg font-concertone my-1" >Date</h2>
                        <h3 className="text-md font-poppins my-1">13 November, 2021</h3>
                    </div>
                    <div className="w-full text-left ">
                        <div className="w-full text-left ">
                            <h2 className="text-lg font-concertone my-1" >Website</h2>
                            <a href="https://nakshi-kaj.web.app/" target="_blank" className="text-md font-poppins my-1 hover:text-red-600">nakshi-kaj.web.app/</a>
                        </div>
                        <h2 className="text-lg font-concertone my-1" >Client Code</h2>
                        <a href="https://nakshi-kaj.web.app/" target="_blank" className="text-md font-poppins my-1 hover:text-red-600">Coming Soon</a>
                    </div>
                    <div className="w-full text-left ">
                        <h2 className="text-lg font-concertone my-1" >Server Repository</h2>
                        <a href="https://nakshi-kaj.web.app/" target="_blank" className="text-md font-poppins my-1 hover:text-red-600">Coming Soon</a>
                    </div>
                </div>
                <div className="w-10/12 h-96 mx-auto min-h-full overflow-y-scroll">
                    <img src={nakshi} className="w-full" />
                </div>
            </div>

        </div>
    );
};

export default ProjectOne;